//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			show: false,
		};
	},

	props: {
		title: {
			default: 'A different approach',
		},
		content: {
			default: 'BPB Auto ...',
		},
		email: {
			default: 'admin@bpbauto.com.au',
		},
		phone: {
			default: '08 8352 1372',
		},
		mobile: {
			default: '0412 345 678',
		},
		linkedIn: {
			default: 'https://www.linkedin.com/company/bpb-auto/',
		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/InternalBanner.vue